export enum NetType {


    //客户端-用户认证管理接口
    CheckRegister= "/hs-apis/acct/v1.0/user/check_register",
    Login= "/hs-apis/acct/v1.0/user/login",
    Logout= "/hs-apis/acct/v1.0/user/logout",
    RefreshToken= "/hs-apis/acct/v1.0/user/refresh_token",
    Register= "/hs-apis/acct/v1.0/user/register",
    ResetPwd= "/hs-apis/acct/v1.0/user/reset_pw",
    GetUserInfo= "/hs-apis/acct/v1.0/user/user_base_info",
    GetUserInitInfo= "/hs-apis/acct/v1.0/user/user_init_info",
    visitorLogin= "/hs-apis/acct/v1.0/user/visitor_login",
    UpdateUser= "/hs-apis/acct/v1.0/user/update",


    //用户数据同步接口
    UserGetData= "/hs-apis/acct/v1.0/user_sync/get_data",
    UserSyncData= "/hs-apis/acct/v1.0/user_sync/sync_data",

    //客户端-短信管理接口
    SendCode= "/hs-apis/acct/v1.0/user_sms/send_code",
    CheckCode= "/hs-apis/acct/v1.0/user_sms/check_code",

    // 客户端-vip配置管理接口
    VipConfigs= "/hs-apis/acct/v1.0/vip/vip_configs",

    //客户端-游戏等级配置管理接口
    GameLevels= "/hs-apis/acct/v1.0/game_levels/list_game_levels",

    //ALL-现金兑换接口
    RedeemApply= "/hs-apis/payout/v1.0/withdraw/apply",//,申请提现
    RedeemApplyDirect= "/hs-apis/payout/v1.0/withdraw/apply_direct",//,同步创建xtg订单的提现接口(参数跟原提现接口一样)
    RedeemCancel= "/hs-apis/payout/v1.0/withdraw/cancel",//,取消提现
    RedeemChannelCheck= "/hs-apis/payout/v1.0/withdraw/channel_check",//渠道提现校验
    RedeemNewCheck= "/hs-apis/payout/v1.0/withdraw/check",//新提现校验

    RedeemEdit= "/hs-apis/payout/v1.0/withdraw/edit",
    RedeemOrderList= "/hs-apis/payout/v1.0/withdraw/order_list",//,提现订单列表
    RedeemConfig= "/hs-apis/payout/v1.0/withdraw/xtg_config",//,打款方式配置
    RedeemBindAccount= "/hs-apis/payout/v1.0/withdraw/bind_account",//,绑定提现渠道帐号信息
    RedeemGetBindCardsInfo= "/hs-apis/payout/v1.0/withdraw/bind_cards",//,查询银行卡绑定结果
    RedeemGetBindCardsLink= "/hs-apis/payout/v1.0/withdraw/card_bind_link",//,获取银行卡绑定链接地址

    // 商店充值相关接口
    PaymentItemsList= "/hs-apis/acct/v1.0/pay_items/list",
    GetXtgConfig= "/hs-apis/pay/v1.0/xtg_config/get_config",
    GetXtgLink= "/hs-apis/pay/v1.0/xtg_config/get_link",
    GetUserLatestOrders= "/hs-apis/pay/v1.0/user_order/latest_order",
    QueryOrder= "/hs-apis/pay/v1.0/user_order/query_order",

    //获取用户奖励相关
    RewardApply= "/hs-apis/acct/v1.0/reward/apply",
    RewardConfig= "/hs-apis/acct/v1.0/reward/get_config",

    //同步UnityGame存储数据
    TransUnityGameData= "/hs-apis/acct/v1.0/local_machine/trans_sync_x",
}